import React from "react";

const NotFoundPage = () => {
  return (
    <div>Pagina nao encontrada</div>
  );
};

export default NotFoundPage;
